module.exports = {
  pathPrefix: '',
  siteUrl: 'https://alexbatrinu.dev',
  siteTitle: 'Alex Batrinu',
  siteDescription: 'Portfolio and blog',
  author: 'Alex Batrinu',
  postsForArchivePage: 3,
  defaultLanguage: 'en',
  disqusScript: process.env.DISQUS_SCRIPT || 'https://alexbatrinu.disqus.com/embed.js',
  pages: {
    home: '/',
    blog: 'blog',
    resume: 'resume',
    tag: 'tags',
  },
  social: {
    github: 'https://github.com/oldmane13',
    linkedin: 'https://www.linkedin.com/in/alex-batrinu-73608b121/',
    email: 'mailto:alexbtrnu@gmail.com',
    twitter: 'https://twitter.com/oldmane13',
    rss: '/rss.xml',
  },
  contactFormUrl: process.env.CONTACT_FORM_ENDPOINT || 'https://getform.io/f/09a3066f-c638-40db-ad59-05e4ed71e451',
  googleAnalyticTrackingId: process.env.GA_TRACKING_ID || 'someId',
  tags: {
    javascript: {
      name: 'javascript',
      description: 'JavaScript is an object-oriented programming language used alongside HTML and CSS to give functionality to web pages.',
      color: '#f0da50',
    },
    gamedev: {
      name: 'gamedev',
      description: 'Everything related to game development, from programming to design.',
      color: '#eb4034',
    },
    reactjs: {
      name: 'reactjs',
      description: 'React is an open source JavaScript library used for designing user interfaces.',
      color: '#61dbfa',
    },
  },
};
